import React, { Fragment, useEffect, useRef, useState } from 'react';
//import '@kitware/vtk.js/favicon'

// Load the rendering pieces we want to use (for both WebGL and WebGPU)
import '@kitware/vtk.js/Rendering/Profiles/Geometry'

import vtkFullScreenRenderWindow from '@kitware/vtk.js/Rendering/Misc/FullScreenRenderWindow';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkXMLImageDataReader from '@kitware/vtk.js/IO/XML/XMLImageDataReader';

import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';

// Force the loading of HttpDataAccessHelper to support gzip decompression
import '@kitware/vtk.js/IO/Core/DataAccessHelper/HttpDataAccessHelper';

const VtkImagesDisplay = ({ data, pageIndex = 0 }) => {
    const vtkContainerRef = useRef(null);
    const context = useRef(null);
    const [dataImages, setDataImages] = useState(null);
    const [isImagesLoading, setIsImagesLoading] = useState(false);


    useEffect(() => {
        const getImageData = async () => {
            setIsImagesLoading(true);
            const dataSend = {
                id_historia: parseInt(data.id_historia),
                id_admision: parseInt(data.id_admision)
            };
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar-imagenes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    if (data.length !== 0) {
                        setDataImages(data);
                        setIsImagesLoading(false);
                        //for (let i = 0; i < data.length; i++) {
                          //  parseImageId(data[i], i);
                        //} 
                        //parseImagesToWadouri(data);
                    } else {
                        setDataImages([]);
                        setIsImagesLoading(false);
                    }

                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }
        //getImageData();
    }, [])

    useEffect(() => {
        if (!context.current) {
            const fullScreenRenderer = vtkFullScreenRenderWindow.newInstance({
                rootContainer: vtkContainerRef.current,
            });
            //fecth data
            const reader = vtkXMLImageDataReader.newInstance();

            const dataSend = {
                id_historia: parseInt(data.id_historia),
                id_admision: parseInt(data.id_admision)
            };
            
            fetch(process.env.REACT_APP_PUBLIC_URL + 'archivos/consultar-imagenes', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            }).then((response)=> response.arrayBuffer())
            .then((data)=>{
                reader.parseAsArrayBuffer(data);
                console.log(reader.getOutputData());
            })

            const renderer = fullScreenRenderer.getRenderer();
            const renderWindow = fullScreenRenderer.getRenderWindow();
        }
    }, [])


    return (
        <Fragment>
            <div ref={vtkContainerRef} />
        </Fragment>
    )
}

export default VtkImagesDisplay 